<script lang="ts">
	import { NavigationMenu as NavigationMenuPrimitive } from "bits-ui";
	import { cn } from "$lib/utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: NavigationMenuPrimitive.LinkProps = $props();
</script>

<NavigationMenuPrimitive.Link
	bind:ref
	data-slot="navigation-menu-link"
	class={cn(
		"data-[active=true]:bg-black/5 hover:bg-black/5 focus:bg-black/5 flex flex-col gap-1 p-3 font-mono text-[14px] text-[#282828] transition-colors outline-none hover:text-black [&_svg:not([class*='text-'])]:text-[#878787] [&_svg:not([class*='size-'])]:size-4",
		className
	)}
	{...restProps}
/>
